/**
 * Fondo abstracto blanco usado en el dashboard y en los formularios de procesos.
 * Manchas suaves con los colores del logo (azul corporativo y llama naranja)
 * sobre una rejilla de puntos tenue. Se usa dentro de `sx` / `style`.
 */
export const ABSTRACT_BACKGROUND = {
  backgroundColor: "#f8fafd",
  backgroundImage: [
    "radial-gradient(circle at 8% 12%, rgba(30, 58, 95, 0.10) 0, transparent 38%)",
    "radial-gradient(circle at 92% 8%, rgba(245, 158, 11, 0.12) 0, transparent 34%)",
    "radial-gradient(circle at 85% 88%, rgba(244, 98, 58, 0.09) 0, transparent 36%)",
    "radial-gradient(circle at 15% 92%, rgba(58, 110, 165, 0.12) 0, transparent 38%)",
    "radial-gradient(rgba(30, 58, 95, 0.10) 1px, transparent 1px)",
  ].join(", "),
  backgroundSize: "100% 100%, 100% 100%, 100% 100%, 100% 100%, 22px 22px",
  backgroundRepeat: "no-repeat, no-repeat, no-repeat, no-repeat, repeat",
} as const;
